import Directory from "../../component/directory/directory.component";

const Home = () => {
  return (
    <div>
      <Directory />;
    </div>
  );
};

export default Home;
